import MatchingSchoolsProvider from './MatchingSchools.provider';

export default MatchingSchoolsProvider;
